import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
// react icons
import CloseIcon from '@mui/icons-material/Close';
import { FaRegUser } from 'react-icons/fa';

// components
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import ApiErrorMessage from '../Global/ApiErrorMessage';
import Footer from '../Global/Footer';
import globalService from '../services/globalServices';
import leadsService from '../services/leadsService';
import OppositeContentTimeline from './OppositeContentTimeline';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

const { AddComment, InternalSalesManager } = leadsService;

const { MasterListType } = globalService;

export default function CommentsLeads() {
  const navigate = useNavigate();
  const [openComments, setOpenComments] = useState(false);
  const [selectRequest, setSelectRequest] = useState(' ');
  const [taskMenu, setTaskMenu] = useState([]);
  const [assignTo, setAssignTo] = useState(' ');
  const [comments, setcomments] = useState('');
  const [open, setOpen] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const [openApiError, setOpenApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [token, setToken] = useState('');
  const [companyId, setCompanyId] = useState();
  const [userId, setUserId] = useState('');
  const [leadDetailsData, setLeadDetailsData] = useState(null);
  const [assignToList, setAssignToList] = useState([]);
  const { LoginData } = useLoginSelector();

  const handleSubmitComments = async (e) => {
    if (selectRequest === ' ') {
      setOpen(true);
      setValidationMsg('Please select task');
      return;
    }
    if (assignTo === ' ') {
      setOpen(true);
      setValidationMsg('Please select assign to');
      return;
    }
    if (comments === '') {
      setOpen(true);
      setValidationMsg('Please add comments');
      return;
    }

    const credentials1 = {
      assignedBy: userId,
      assignedTo: assignTo,
      comments: comments,
      companyId: companyId,
      leadId: leadDetailsData !== null ? leadDetailsData.leadesItem[0].leadId : null,
      taskId: selectRequest
    };
    const AddCommentApiResponse = await AddComment(credentials1, token);
    if (AddCommentApiResponse.status === 'success') {
      setOpenComments(false);
      setSelectRequest(' ');
      setAssignTo(' ');
      setcomments('');
    } else {
      setOpenApiError(true);
      setErrorMessage('Something went wrong !');
    }
  };

  useEffect(async () => {
    let leadDetails = localStorage.getItem('leadDetails');
    leadDetails = JSON.parse(leadDetails);
    setLeadDetailsData(leadDetails);
    if (LoginData !== null) {
      const authToken = LoginData?.jwt;
      setToken(authToken);
      const authCompanyId = LoginData?.companyId;
      setCompanyId(authCompanyId);
      const authUserId = LoginData?.userId;
      setUserId(authUserId);
      const type = 'LEAD_COMMENT_TASK_TYPE';
      const AddressTypeApiResponse = await MasterListType(type, authToken);
      if (AddressTypeApiResponse.status === 'success') {
        setTaskMenu(AddressTypeApiResponse.data.masterTypes);
      } else {
        setTaskMenu([]);
      }

      const credentials2 = {
        companyId: authCompanyId
      };
      const InternalSalesManagerApiResponse = await InternalSalesManager(credentials2, authToken);
      if (InternalSalesManagerApiResponse.msg) {
        if (InternalSalesManagerApiResponse.msg === 'Forbidden') {
          navigate('/');
        }
      }
      if (InternalSalesManagerApiResponse.status === 'success') {
        const finalData = InternalSalesManagerApiResponse.data.salesPersons.filter(
          (item, index) => authUserId !== item.userId
        );
        setAssignToList(finalData);
      } else {
        setAssignToList([]);
      }
    }
  }, []);

  return (
    <Page title="Comments">
      <Box className="mainBg" pb={4}>
        <Container maxWidth={false}>
          <Box pt={3} pb={3}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              className="pageHeading"
            >
              <PageTitle info="Comments" />
              <Box>
                <BrudCrumbs />
              </Box>
            </Stack>

            {/* applicant details */}
            <Typography variant="body1" className="headingLineUp headingLineUpOut">
              Application Details
            </Typography>
            <Box className="viewLeadCard cardTopMinusMargin" mb={3}>
              <Grid item container spacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="displayFlex">
                    <FaRegUser className="viewLabelIcon" size={24} />
                    <Box>
                      <Typography variant="body1" className="reviewLabel">
                        Application No
                      </Typography>
                      <Typography variant="subtitle2" className="reviewValue">
                        123456789
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="displayFlex">
                    <FaRegUser className="viewLabelIcon" size={24} />
                    <Box>
                      <Typography variant="body1" className="reviewLabel">
                        Submitted On
                      </Typography>
                      <Typography variant="subtitle2" className="reviewValue">
                        01/06/2022
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="displayFlex">
                    <FaRegUser className="viewLabelIcon" size={24} />
                    <Box>
                      <Typography variant="body1" className="reviewLabel">
                        Submitted by
                      </Typography>
                      <Typography variant="subtitle2" className="reviewValue">
                        Ramesh
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="displayFlex">
                    <FaRegUser className="viewLabelIcon" size={24} />
                    <Box>
                      <Typography variant="body1" className="reviewLabel">
                        Mode of Submission
                      </Typography>
                      <Typography variant="subtitle2" className="reviewValue">
                        Online
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="displayFlex">
                    <FaRegUser className="viewLabelIcon" size={24} />
                    <Box>
                      <Typography variant="body1" className="reviewLabel">
                        Customer Type
                      </Typography>
                      <Typography variant="subtitle2" className="reviewValue">
                        Banking
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="displayFlex">
                    <FaRegUser className="viewLabelIcon" size={24} />
                    <Box>
                      <Typography variant="body1" className="reviewLabel">
                        Product
                      </Typography>
                      <Typography variant="subtitle2" className="reviewValue">
                        Home Loan
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="displayFlex">
                    <FaRegUser className="viewLabelIcon" size={24} />
                    <Box>
                      <Typography variant="body1" className="reviewLabel">
                        Customer ID
                      </Typography>
                      <Typography variant="subtitle2" className="reviewValue">
                        A1B1
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="displayFlex">
                    <FaRegUser className="viewLabelIcon" size={24} />
                    <Box>
                      <Typography variant="body1" className="reviewLabel">
                        Last KYC Update
                      </Typography>
                      <Typography variant="subtitle2" className="reviewValue">
                        06/06/2022
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="displayFlex">
                    <FaRegUser className="viewLabelIcon" size={24} />
                    <Box>
                      <Typography variant="body1" className="reviewLabel">
                        Verified by
                      </Typography>
                      <Typography variant="subtitle2" className="reviewValue">
                        ABC
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="displayFlex">
                    <FaRegUser className="viewLabelIcon" size={24} />
                    <Box>
                      <Typography variant="body1" className="reviewLabel">
                        Verified on
                      </Typography>
                      <Typography variant="subtitle2" className="reviewValue">
                        08/11/2022
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="displayFlex">
                    <FaRegUser className="viewLabelIcon" size={24} />
                    <Box>
                      <Typography variant="body1" className="reviewLabel">
                        Verifier Type
                      </Typography>
                      <Typography variant="subtitle2" className="reviewValue">
                        Bank/3rd Party
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box className="displayFlex">
                    <FaRegUser className="viewLabelIcon" size={24} />
                    <Box>
                      <Typography variant="body1" className="reviewLabel">
                        Verified Location
                      </Typography>
                      <Typography variant="subtitle2" className="reviewValue">
                        Jaipur
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box textAlign="right" mb={2}>
              <Button className="mainBtn" onClick={(e) => setOpenComments(true)}>
                Add Comments
              </Button>
            </Box>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                <Typography variant="body1" className="headingLineUp headingLineUpOut">
                  Latest
                </Typography>
                <Box
                  className="viewLeadCard cardTopMinusMargin"
                  sx={{ height: '50vh', overflow: 'auto' }}
                >
                  <OppositeContentTimeline />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography variant="body1" className="headingLineUp headingLineUpOut">
                  Last 12 Months
                </Typography>
                <Box
                  className="viewLeadCard cardTopMinusMargin"
                  sx={{ height: '50vh', overflow: 'auto' }}
                >
                  <OppositeContentTimeline />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography variant="body1" className="headingLineUp headingLineUpOut">
                  Historical
                </Typography>
                <Box
                  className="viewLeadCard cardTopMinusMargin"
                  sx={{ height: '50vh', overflow: 'auto' }}
                >
                  <OppositeContentTimeline />
                </Box>
              </Grid>
            </Grid>
            {/* popup start */}
            <Dialog
              open={openComments}
              // onClose={(e) => setOpenComments(false)}
              fullWidth
            >
              <DialogTitle className="popupTitle">
                <Typography variant="h6">Add New Comments</Typography>
                <IconButton
                  onClick={(e) => {
                    setOpenComments(false);
                    setSelectRequest(' ');
                    setAssignTo(' ');
                    setcomments('');
                  }}
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <Typography variant="h6" className="formLabel">
                      Task
                    </Typography>
                    <Select
                      fullWidth
                      inputProps={{
                        className: `textInput customSelectBox dissabledMenu${selectRequest}`
                      }}
                      value={selectRequest}
                      onChange={(e) => setSelectRequest(e.target.value)}
                    >
                      <MenuItem value=" " disabled>
                        Task
                      </MenuItem>
                      {taskMenu.length > 0
                        ? taskMenu.map((item, index) => (
                            <MenuItem value={item.typeId} key={index}>
                              {item.typeName}
                            </MenuItem>
                          ))
                        : ''}
                    </Select>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Typography variant="h6" className="formLabel">
                      Assign to
                    </Typography>
                    <Select
                      fullWidth
                      inputProps={{
                        className: `textInput customSelectBox dissabledMenu${assignTo}`
                      }}
                      value={assignTo}
                      onChange={(e) => {
                        setAssignTo(e.target.value);
                      }}
                    >
                      <MenuItem value=" " disabled>
                        Select Assign To
                      </MenuItem>
                      {assignToList.length > 0
                        ? assignToList.map((item, index) => {
                            console.log(item);
                            return <MenuItem value={item.userId}>{item.fullName}</MenuItem>;
                          })
                        : ''}
                    </Select>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Typography variant="h6" className="formLabel">
                      Comments
                    </Typography>
                    <TextField
                      fullWidth
                      type="textarea"
                      multiline
                      row={3}
                      inputProps={{
                        className: 'textInput'
                      }}
                      placeholder="Comments"
                      value={comments}
                      onChange={(e) => setcomments(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={(e) => {
                    setOpenComments(false);
                    setSelectRequest(' ');
                    setAssignTo(' ');
                    setcomments('');
                  }}
                  variant="contained"
                  className="mainBtn"
                >
                  Close
                </Button>
                <Button
                  onClick={(e) => {
                    handleSubmitComments(e);
                  }}
                  variant="contained"
                  className="mainBtn"
                >
                  Submit
                </Button>
              </DialogActions>
            </Dialog>
            {/* Create list popup end */}
          </Box>
          <Dialog
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">{validationMsg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={(e) => setOpen(false)}>Retry</Button>
            </DialogActions>
          </Dialog>

          <ApiErrorMessage
            openApiError={openApiError}
            setOpenApiError={setOpenApiError}
            errorMessage={errorMessage}
          />
        </Container>
        <Footer />
      </Box>
    </Page>
  );
}
